import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import alphabetizeBy from "../../../helpers/alphabetizeBy";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Card,
  CardHeader,
  CardBody,
  Button
} from "reactstrap";
import Alert from "../../Widgets/Alert";
import withAlertTimeout from "../../../HOCs/withAlertTimeout";
import LoaderSpinner from "../../Widgets/LoaderSpinner";
import ConfirmationModal from "../../Components/ConfirmationModal";

//${resourceURL}

const CreateCategoryGroup = props => {
  let prehydratedData = {};
  if (props.location.state && props.location.state.categoryGroup) {
    prehydratedData = props.location.state.categoryGroup;
  }

  const [groupName, setGroupName] = useState(prehydratedData.name || "");
  const [categories, setCategories] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [categoryLookup, setCategoryLookup] = useState({});
  const [selectedCategories, setSelectedCategories] = useState(
    prehydratedData.gnCategories || []
  );
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [redirectURL, setRedirectURL] = useState(null);

  const token = sessionStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  const resourceURL = props.match.params.id
    ? `/api/proxy/v2/partneradmin/${props.match.params.id}/categoryGroup`
    : `/api/proxy/v2/categoryGroup`;

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(
    () => {
      setCategoryLookup(createLookup(categories));
    },
    [categories, categories.length]
  );

  useEffect(
    () => {
      if (props.isEdit && !Object.keys(prehydratedData).length) {
        fetchCategoryGroup();
      }
    },
    [props.isEdit, Object.keys(prehydratedData).length]
  );

  const fetchCategoryGroup = async () => {
    const {
      match: { params }
    } = props;

    try {
      setIsFetching(true);
      const { data } = await axios.get(`${resourceURL}/${params.categoryId}`, {
        headers
      });
      setGroupName(data.name);
      setSelectedCategories(data.gnCategories);
    } catch (e) {
      console.log(e.response);
      if (e.response.status === 404) {
        setRedirectURL("/");
      }
    } finally {
      setIsFetching(false);
    }
  };

  const onNameInput = e => {
    setGroupName(e.target.value);
  };

  const onCategorySelect = e => {
    const categoryId = e.target.value;
    setSelectedCategories(prev => [...prev, categoryId]);
  };

  const removeCategory = index => {
    return () => {
      setSelectedCategories(prevValue => [
        ...prevValue.slice(0, index),
        ...prevValue.slice(index + 1)
      ]);
    };
  };

  const fetchCategories = () => {
    axios
      .get("/api/proxy/v2/categories")
      .then(({ data }) => {
        const sorted = alphabetizeBy("categoryName", data);
        setCategories(sorted);
      })
      .catch(err => console.log(err));
  };

  const onSubmit = () => {
    const payload = {
      name: groupName,
      gnCategoryIds: selectedCategories
    };

    setIsSubmitting(true);

    axios({
      method: props.isEdit ? "put" : "post",
      url: props.isEdit
        ? `${resourceURL}/${props.match.params.categoryId}`
        : `${resourceURL}`,
      headers,
      data: payload
    })
      .then(onSuccess)
      .catch(e => {
        console.log(e);
        props.showFailure();
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const deleteGroup = async () => {
    try {
      await axios.delete(`${resourceURL}/${props.match.params.categoryId}`, {
        headers
      });
      setDeleteConfirmationModal(false);
      props.showSuccess();
      setRedirectURL(props.location.state.referrer);
    } catch (e) {
      props.showFailure();
    }
  };

  const renderCategories = () => {
    return categories.map(cat => (
      <option key={cat.id} value={cat.id} onChange={onCategorySelect}>
        {cat.categoryName}
      </option>
    ));
  };

  const createLookup = categories => {
    return categories.reduce((acc, curr) => {
      acc[curr.id] = curr.categoryName;
      return acc;
    }, {});
  };

  const renderSelected = () => {
    return selectedCategories.map((id, idx) => (
      <div className="pill" key={id}>
        {categoryLookup[id]}{" "}
        <i
          onClick={removeCategory(idx)}
          className="icon-close"
          style={{ fontSize: 16, marginLeft: 5, cursor: "pointer" }}
        />
      </div>
    ));
  };

  const onSuccess = () => {
    props.showSuccess();

    if (!props.isEdit) {
      clearForm();
    }
  };

  const clearForm = () => {
    setGroupName("");
    setSelectedCategories([]);
  };

  if (redirectURL) {
    return <Redirect to={redirectURL} />;
  }

  return (
    <Card>
      <ConfirmationModal
        message={
          "Are you sure you want to delete this category Group? This action is permanent."
        }
        open={deleteConfirmationModal}
        close={() => setDeleteConfirmationModal(false)}
        onConfirm={deleteGroup}
        isSubmitting={isSubmitting}
      />
      {
        <Alert
          active={props.success}
          message={props.isEdit ? "Group Updated" : "Group Created"}
        />
      }
      {
        <Alert
          type="danger"
          active={props.failure}
          message="Something went wrong, please try again"
        />
      }
      <CardHeader>
        Create Category Group
        {props.location.state ? ` for ${props.location.state.partnerName}` : ""}
      </CardHeader>
      <CardBody>
        <Col md={{ size: 6, offset: 3 }} xs="12">
          {isFetching ? (
            <LoaderSpinner />
          ) : (
            <React.Fragment>
              <FormGroup>
                <Label htmlFor="partner name">Group Name (required)</Label>
                <Input
                  type="text"
                  // id="add-category-input"
                  value={groupName}
                  // onKeyPress={onKeyPress}
                  onChange={onNameInput}
                />

                <Label htmlFor="categories" style={{ marginTop: 10 }}>
                  Categories
                </Label>
                <div
                  className={`${
                    selectedCategories.length ? "pill-container" : ""
                  }`}
                >
                  {renderSelected()}
                </div>
                <Input
                  type="select"
                  name="select"
                  id="select"
                  onChange={onCategorySelect}
                  style={{ marginTop: 10 }}
                >
                  <option default value={null}>
                    Select a Categories
                  </option>
                  {renderCategories()}
                </Input>
                <Button
                  style={{ float: "right" }}
                  type="submit"
                  color="primary"
                  onClick={onSubmit}
                  disabled={!groupName.length}
                >
                  {isSubmitting && (
                    <i
                      className="fa fa-circle-o-notch fa-spin"
                      style={{ marginRight: 5 }}
                    />
                  )}
                  Submit
                </Button>
              </FormGroup>
            </React.Fragment>
          )}
        </Col>
      </CardBody>
      {props.isEdit ? (
        <Button
          // disabled={!partnerData}
          onClick={() => setDeleteConfirmationModal(true)}
          style={{
            marginTop: 10,
            color: "#f2014b",
            border: "1px solid #f2014b",
            backgroundColor: "transparent",
            width: "25%",
            marginLeft: "74%",
            marginBottom: 10
          }}
        >
          Delete This Group
        </Button>
      ) : null}
    </Card>
  );
};

export default withAlertTimeout(CreateCategoryGroup);



// WEBPACK FOOTER //
// ./src/views/Pages/Partnership/CreateCategoryGroup.js